import { watchGetLoyaltyGiftMenuSaga } from "./getLoyaltyGiftMenuSaga";
import { watchGetMultiPosGiftGroupsSaga } from "./getMultiPosGiftGroupsSaga";
import { watchGetGiftGroupsSaga } from "./getGiftGroupsSaga";
import { watchModifyMultiPosGiftGroupsSaga } from "./modifyMultiPosGiftGroupsSaga";
import { watchModifyGiftGroupsSaga } from "./modifyGiftGroupsSaga";
const giftsSagas = [
  watchGetLoyaltyGiftMenuSaga(),
  watchGetMultiPosGiftGroupsSaga(),
  watchGetGiftGroupsSaga(),
  watchModifyMultiPosGiftGroupsSaga(),
  watchModifyGiftGroupsSaga(),
];

export default giftsSagas;
